import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { debounce, getTextNodesIn } from '../functions'

imagesLoaded.makeJQueryPlugin($)

let partnerTypes = $('[data-faq-categories]').attr('data-faq-categories')


let catIso = ''

const parent = $('.js-cat-iso')
if (parent.length != 0) {
  catIso = new Isotope('.js-cat-iso', {
    itemSelector: '.js-cat-iso-item',
    transitionDuration: 400,
  })

  parent.imagesLoaded(function () {
    catIso.layout()
  })

  $('.js-select').on('change', function () {
    const vals = [$(this).val()]

    if (vals.length === 0) {
      catIso.arrange({ filter: '*' })
      return
    }

    catIso.arrange({
      filter: function () {
        const posts = $(this)

        const attr = posts.attr('data-categories')
        const categories = attr.includes(',') ? attr.split(',') : [attr]
        const newCategories = categories.map(Number)
        let hasCategory = false

        if (newCategories.length > 0) {
          for (let i = 0; i < vals.length; i++) {
            if (
                newCategories.includes(parseInt(vals[i])) ||
                vals[i] === 'all'
            ) {
              hasCategory = true
            }
          }
        }

        const post = $(this)
        const text = getTextNodesIn(post[0])
        const qsRegex = new RegExp($('.pt-faq input[type="text"]').val(), 'gi')

        let hasText = qsRegex ? text.match(qsRegex) : true

        return hasCategory && hasText
      },
    })
  })
}
